import { logout } from '../../../data/repositories/authRepository.js';

export const logoutUser = () => logout();
